import axios from 'axios';
import {BaseResponse} from "../../BaseResponse";
import {GasProductRegistRequest} from "./gasProductRegistration";


export async function putGasProductRegistration(uid : string, request: GasProductRegistRequest) {
    const response = await axios.put<BaseResponse<boolean>>(`/basic/gas_product/${uid}`, request)
    return response.data
}